<!-- @format -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import Button from "../Button.svelte";
  export let offer: ManageAPI.Offer;
  export let request_store_key: StoresKey;
  const { reverse_router, stores, scdata, site, T } = getStoresContext(request_store_key);
  $: store = $stores && $stores.find((store) => store.id == offer.store?.id);
  $: store_href = store ? $reverse_router.routeStore(store, $scdata) : '';
  $: logo = store?.logoURL;
  $: alt = store?.name || $site.name;
  $: url = $reverse_router.routeOffer(offer, $scdata, $stores);
  $: t = $T;
</script>

<div class="square cut-bottom-left mb-3">
  {#if offer.images && offer.images.length}
    <img src={offer.images.at(0)} alt={alt} />
  {:else}
    <img src={logo} alt={alt} />
  {/if}
</div>
<div class="pb-3 px-3">
  <div class="offer-detailn">
    {#if store}
      <a class="mb-2 publisher text-gray" href={store_href}>{alt}</a>
    {:else}
      <span class="mb-2 publisher text-gray">{alt}</span>
    {/if}
    <p class="offer-title mb-1">{offer.title}</p>
    <p class="mb-1">{offer.description1} {offer.description2}</p>
    {#if offer.longDescription}
      <p class="my-md-2 mt-1 mb-0 longDescription">{offer.longDescription}</p>
    {/if}
  </div>

  {#if offer.url == 'automatic'}
    <div class="link-button p-0 mt-xl-3 my-2">
      <Button href={store_href}>{t`go to store`}</Button>
    </div>
  {:else if url}
    <div class="link-button p-0 mt-xl-3 my-2">
      <Button href={url} target="_blank">{t`show more`}</Button>
    </div>
  {/if}
</div>

<style lang="scss">
  .offer-detail {
    max-height: 18vh;
    overflow: auto;
    @media screen and (min-width: 992px) {
      max-height: 25vh;
    }
  }
  .longDescription {
    font-size: 15px;
    @media screen and (min-width: 768px) {
      font-size: 18px;
    }
  }
  .offer-title {
    font-weight: 500;
  }
  .link-button {
    margin-left: auto;
    display: block;
    text-align: center;
    @media screen and (min-width: 992px) {
      display: inline-block;
    }
  }
  .publisher {
    font-size: 16px;
  }
  a.publisher {
    text-decoration: underline;
  }
  .square {
    position: relative;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2rem;
    aspect-ratio: 1/1;
  }

  .square img {
    max-width: 100%;
    max-height: 100%;
  }
</style>
